import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { Box } from '@mui/material';
import { useState, useEffect } from 'react';
import WhatsAppButton from '../Components/WhatsAppButton';
import Lenis from 'lenis';

const Layout = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(location.pathname);
  const [isScrolled, setIsScrolled] = useState(false);
  const [reveal, setReveal] = useState(false);

  useEffect(() => {
    // Initialize Lenis smooth scrolling
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Smooth easing
      smoothWheel: true,
    });

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => {
      lenis.destroy(); // Clean up Lenis instance
    };
  }, []);

  useEffect(() => {
    // Trigger fade-in animation on mount
    const timeout = setTimeout(() => setReveal(true), 100);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    // Scroll to the top of the page whenever the route changes
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Update selectedTab when the route changes
    setSelectedTab(location.pathname);
  }, [location.pathname]);

  const styles = {
    blackOverlay: {
      position: 'fixed' as 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'black',
      zIndex: 999,
      opacity: reveal ? 0 : 1,
      transition: 'opacity 2.5s cubic-bezier(0.22, 1, 0.36, 1)', // Ultra-smooth easing
      pointerEvents: reveal ? 'none' as React.CSSProperties['pointerEvents'] : 'auto' as React.CSSProperties['pointerEvents'],
    },
    layoutContainer: {
      opacity: reveal ? 1 : 0,
      transition: 'opacity 2.5s cubic-bezier(0.22, 1, 0.36, 1), transform 2.5s cubic-bezier(0.22, 1, 0.36, 1)', // Ultra-smooth easing
    },
    headerContainer: {
      position: 'fixed' as 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      zIndex: 1000,
      backgroundColor: isScrolled ? 'rgba(0, 0, 0, 0.9)' : 'transparent',
      transition: 'background 0.3s ease-in-out',
    },
  };

  return (
    <Box sx={{ height: '100vh', position: 'relative' }}>
      <div style={styles.blackOverlay}></div>
      <div style={styles.layoutContainer}>
        <Box style={styles.headerContainer}>
          <Header selectedTab={selectedTab} onTabChange={setSelectedTab} />
        </Box>
        <Box sx={{ mt: 0 }}>
          <Outlet />
        </Box>
        <Footer />
        <WhatsAppButton />
      </div>
    </Box>
  );
};

export default Layout;